import { Text } from "@otrium/atoms";
import styled from "@emotion/styled";

const Wrapper = styled.a`
  align-items: center;
  border-bottom: solid 1px ${({ theme }) => theme.colors.primary.platinumLight};
  display: flex;
  padding: ${({ theme }) => theme.space[3]}px ${({ theme }) => theme.space[0]};
`;

const Title = styled(Text)`
  font-weight: bold;
  line-height: 1.33;
  padding: ${({ theme }) => theme.space[0]};
`;

const RightAdornment = styled.div`
  margin-left: auto;
`;

export { Wrapper, Title, RightAdornment };
